













































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import BulkEditOffersTrigger from './BulkEditOffersTrigger.coffee'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'

settings =
  name: 'BulkEditOffersTrigger'

  vue:
    props: ['resourceComponent', 'resourceKey']
    mixins: [BulkEditOffersTrigger.trigger()]

    components: {
      Modal,
      RequestButton,
      FormFieldRadioButton,
    }

    data: ->
      currentTab: 'offers'
      offerIdsStr: ''
      purchaseOrderIdsStr: ''

    computed:
      canBulkEdit: ->
        @modal.data.action and (@selectedOfferIds.length or @selectedPurchaseOrderIds.length)

      selectedOfferIds: ->
        @offerIdsStr.trim().split(/[\s,]+/).filter(Boolean)

      selectedPurchaseOrderIds: ->
        @purchaseOrderIdsStr.trim().split(/[\s,]+/).filter(Boolean)

      optionsForActions: ->
        [
          { label: 'Accept', value: 'accept' }
          { label: 'Deny', value: 'deny' }
          { label: 'Cancel', value: 'cancel' }
          { label: 'Void', value: 'void' }
          { label: 'Change dates', value: 'change_dates' }
        ]

      optionsForVoidedBy: ->
        [
          { label: 'Organizer', value: 'organizer' }
          { label: 'Sponsor', value: 'sponsor' }
        ]

    methods:
      modalData: ->
        offer_ids: null
        purchase_order_ids: null
        action: null
        voided_by: null
        void_reason: null
        denial_reason: null
        activation_dates: null

      hiTabClick: ->
        @offerIdsStr = ''
        @purchaseOrderIdsStr = ''
        @refreshPayloadData()

      hiOfferIds: ->
        @refreshPayloadData()

      hiPurchaseOrderIds: ->
        @refreshPayloadData()

      hiChangeAction: ->
        @modal.data.voided_by = null
        @modal.data.void_reason = null
        @modal.data.denial_reason = null
        @modal.data.activation_dates = null

      refreshPayloadData: ->
        @modal.data.offer_ids = @selectedOfferIds
        @modal.data.purchase_order_ids = @selectedPurchaseOrderIds

    watch:
      'modal.show': (value) ->
        return unless value
        @currentTab = @modal.config?.currentTab || 'offers'
        @offerIdsStr = @modal.config?.offerIds?.join(', ') || ''
        @purchaseOrderIdsStr = @modal.config?.purchaseOrderIds?.join(', ') || ''
        @refreshPayloadData()

export default VueOptions.vue settings
